import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { IS_IN_PURCHASE, localStorageKeys, SECTION_TYPE } from '../utils/Constants';
import { useFujiAuth } from '../auth/useFujiAuth';
import { RootState } from 'redux/reducers/rootReducer';
import { LocalReservationDataType } from 'types/reservationInfoData';

export function useReservationFlow() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const localReservation: LocalReservationDataType = JSON.parse(localStorage.getItem(localStorageKeys.RESERVATION_INFO_DATA) ?? '{}');
    const { isEdit, reservationCombo = [] } = localReservation;

    const { isAuthenticated } = useFujiAuth();

    const { currentIndex } = useSelector((state: RootState) => state.reservationFlow);

    const goToStep = (step: string) => {
        navigate(`/buy/reservation/${step}`);
    };

    const moveToNextTicketOrUserInfo = () => {
        const nextIndex = currentIndex + 1;
        if (nextIndex < reservationCombo.length) {
            dispatch({
                type: 'RESERVATION_FLOW',
                payload: {
                    currentIndex: nextIndex,
                },
            });
            const container: HTMLElement | null = document.querySelector('.scrollable');
            container?.scroll({
                top: 0,
                behavior: 'smooth',
            });
            goToStep('calendar');
        } else if (isEdit) {
            goToStep(`confirm`);
        } else if (!isAuthenticated) {
            localStorage.setItem(IS_IN_PURCHASE, 'true');
            localStorage.setItem(
                localStorageKeys.LOGIN_FLOW,
                JSON.stringify({
                    path: `/buy/reservation/user-info`,
                }),
            );
            navigate('/auth');
        } else {
            goToStep(`user-info`);
        }
    };

    const next = (currentStep: string) => {
        const currentTicket = reservationCombo[currentIndex];

        if (currentStep === `calendar`) {
            if (currentTicket.sectionType === SECTION_TYPE.MULTI) {
                goToStep(`section`);
            } else {
                moveToNextTicketOrUserInfo();
            }
        } else if (currentStep === `section`) {
            moveToNextTicketOrUserInfo();
        } else if (currentStep === `user-info`) {
            goToStep(`confirm`);
        } else {
            goToStep(`calendar`);
        }
    };

    const back = (currentStep?: string) => {
        if (currentStep === `user-info`) {
            const lastIndex = reservationCombo.length - 1;
            dispatch({
                type: 'RESERVATION_FLOW',
                payload: {
                    currentIndex: lastIndex,
                },
            });
        }
        if (currentStep === `calendar`) {
            if (currentIndex > 0) {
                const prevIndex = currentIndex - 1;
                dispatch({
                    type: 'RESERVATION_FLOW',
                    payload: {
                        currentIndex: prevIndex,
                    },
                });
            }
        }
        navigate(-1);
    };

    return {
        currentIndex,
        ...localReservation,
        localReservation,
        next,
        back,
        goToStep,
    };
}
